/*  ========================================================================
    # Sections - Product Overview
    ========================================================================  */
import React from 'react';
import { MotionConfig } from 'motion/react';
import PropTypes from 'prop-types';
import ProductSlider from './ProductSlider';
import ProductPaymentTypes from './ProductPaymentTypes';
import ProductCard from '../../components/ProductCard';

const ProductOveriew = ({ image, content, hideProductImages, products, showPaymentTypes, paymentTypes, paymentTypesDescription }) => {
  return (
    <MotionConfig reducedMotion='user'>
      <div className={`s-product-overview__header ${products.length === 1 ? 's-product-overview__header--single' : ''}`}>
        <div className='container'>
          <div className={`s-product-overview__header-wrapper ${!image && products.length > 1 ? 'no-image' : ''}`}>
            <div className='s-product-overview__content wysiwyg-block' dangerouslySetInnerHTML={{ __html: content }}></div>
            {products.length === 1 && (
              <div className='s-product-overview__header-product'>
                <ProductCard
                  hideImage={hideProductImages}
                  upsellingContent={products[0]['showUpselling'] ? products[0]['upsellingContent'] : null}
                  product={products[0].product}
                />
              </div>
            )}
            {image && products.length > 1 && (
              <div className='s-product-overview__image'>
                <figure>
                  <img srcSet={`${image.sizes['medium']}, ${image.sizes['medium_large']} 2x`} src={image.sizes['medium_large']} alt={image['alt']} />
                </figure>
              </div>
            )}

            {products.length === 1 && showPaymentTypes && (
              <ProductPaymentTypes types={paymentTypes} description={paymentTypesDescription} />
            )}
          </div>
        </div>
      </div>
      {products.length > 1 && (
        <div className='container'>
          <ProductSlider products={products} hideProductImages={hideProductImages} />
        </div>
      )}

      {products.length > 1 && showPaymentTypes && (
        <div className='container'>
          <ProductPaymentTypes types={paymentTypes} description={paymentTypesDescription} />
        </div>
      )}
    </MotionConfig>
  );
};

ProductOveriew.propTypes = {
  image: PropTypes.array,
  content: PropTypes.string,
  hideProductImages: PropTypes.bool,
  products: PropTypes.array,
  showPaymentTypes: PropTypes.bool,
  paymentTypes: PropTypes.array,
  paymentTypesDescription: PropTypes.string
};

export default ProductOveriew;
